import { Box, Typography, useTheme, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format_Number } from '../../utils/utils';
import { setUpdateTotalVAT } from '../../store/slice/Addguest.slice';

const PaymentCard = ({
    // reservType, selectedExtraProduct, transactionDetails, languageWords,selectedCombination
    transactionPrice,excludingVat,totalVat,totalIncludingVAT,languageWords,transactionDetails,total_product_price,cardCss
}) => {
 
  const theme = useTheme();
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(setUpdateTotalVAT(totalIncludingVAT))
  },[totalIncludingVAT])
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '220px',
      //  border: `1px dotted ${theme?.details?.detailsBorderColor}`,
        backgroundColor: cardCss?.CardSectionBgClr,
        borderRadius: '8px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        p: 2,
        mt: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0px 6px 14px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Typography
        sx={{
          color: cardCss?.CardSectionHeadingClr,
         
          fontSize: "1rem",
          mb: 0.5,
        }}
      >
        {languageWords?.Payment}
      </Typography>

      {totalIncludingVAT > 0 && !isNaN(totalIncludingVAT) && (
        <>
          <Divider sx={{ mb: 2, borderColor: '#969BA0' }} /> 
      {transactionPrice > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography sx={{ color:  cardCss?.CardSectionInfoClr, fontSize: '12px',  }}>
            {transactionDetails?.languages[0]?.data}
          </Typography>
          <Typography sx={{ color: cardCss?.CardSectionPriceClr, fontSize: '12px',mr:3.5}}>
            €{format_Number(parseFloat(transactionPrice).toFixed(2))}
          </Typography>
        </Box>
      )}
           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.7 }}>
            <Typography sx={{ color: cardCss?.CardSectionInfoClr, fontSize: '14px' }}>
              {languageWords['excludingVAT']}
            </Typography>
            <Typography sx={{ color: cardCss?.CardSectionPriceClr, fontSize: '12px',mr:3.5 }}>
              €{format_Number(parseFloat(excludingVat).toFixed(2))}
            </Typography>
          </Box>
        </>
      )}


      {totalVat > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.7 }}>
          <Typography sx={{ color: cardCss?.CardSectionInfoClr, fontSize: '14px'}}>
            {languageWords?.VAT}
          </Typography>
          <Typography sx={{ color: cardCss?.CardSectionPriceClr, fontSize: '12px',mr:3.5}}>
            €{format_Number(parseFloat(totalVat).toFixed(2))}
          </Typography>
        </Box>
      )}

      {totalIncludingVAT > 0 && !isNaN(totalIncludingVAT) && (
        <>
          <Divider sx={{ mb: 2, borderColor: '#969BA0' }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '1rem', color: cardCss?.CardSectionInfoClr, fontWeight: '700' }}>
              {languageWords['TotalIncludingVAT']}
            </Typography>
            <Typography sx={{ color: cardCss?.CardSectionPriceClr, fontSize: '12px', fontWeight: '700',mr:3.5 }}>
              €{format_Number(parseFloat(totalIncludingVAT).toFixed(2))}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default PaymentCard;